import { render, staticRenderFns } from "./BannerBlock.vue?vue&type=template&id=3d6019de"
import script from "./BannerBlock.vue?vue&type=script&lang=js"
export * from "./BannerBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports